import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import style from "./AviationExpeditorActionsTab.module.scss";
import { Aviation } from "../../../../../services";
import CustomButton from "../../../../custom/custom-button/CustomButton";
import ConfirmActionModal from "../../../../orders-new/order-info-expeditor/components/ConfirmActionModal/ConfirmActionModal";

const AviationExpeditorReturnAction = ({ order, fetchOrderData, onForceUpdate }) => {
  const { t } = useTranslation();
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    if (!order?.id) return;

    try {
      setIsLoading(true);
      await Aviation.updateStatus(order.id, "delivered");
      toast.success(t("orderInfoExpeditor.actions.resubmittedToModeration"));
      setIsConfirmOpen(false);
      await fetchOrderData?.();
      onForceUpdate?.();
    } catch (error) {
      console.error(error);
      toast.error(t("orderInfo.genericError"));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={style.card}>
      <div className={style.topbar}>
        <span className={style.topbar_title}>
          {t("orderInfoExpeditor.actions.returnFixTitle")}
        </span>
      </div>

      <div className={style.comment_box}>
        <div className={style.comment_label_row}>
          <span className={style.comment_label}>
            {t("orderInfoExpeditor.actions.partnerCommentLabel")}
          </span>
        </div>
        <span className={style.comment_text}>{order?.rejectReason || "-"}</span>
      </div>

      <div className={style.actions_row_full}>
        <CustomButton
          text={t("orderInfoExpeditor.actions.resubmitToPartner")}
          isNavy
          onClick={() => setIsConfirmOpen(true)}
          isLoading={isLoading}
          disabled={isLoading}
          style={{ width: "100%" }}
        />
      </div>

      <ConfirmActionModal
        isOpen={isConfirmOpen}
        title={t("orderInfoExpeditor.actions.resubmitConfirmTitle")}
        message={t("orderInfoExpeditor.actions.resubmitConfirmMessage")}
        onConfirm={handleConfirm}
        onCancel={() => setIsConfirmOpen(false)}
        isLoading={isLoading}
      />
    </div>
  );
};

export default AviationExpeditorReturnAction;
